import React from "react";

import PropTypes from "prop-types";
import { Eye, EyeSlash } from "react-bootstrap-icons";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";

import withMapActions from "./withMapActions";

const TopicLayerSelector = (props) => {
  const { label, ids, setLayersVisibility } = props;
  const layers = useSelector((state) => state.interactiveMap.layers);

  const visible = ids.every((id) => layers[id].visible);

  const handleClick = () => {
    setLayersVisibility(ids, !visible);
  };

  return (
    <Button
      onClick={handleClick}
      variant="outline-primary"
      className="mt-2 text-left"
      block
    >
      <span className="toggle-button-icon">
        {visible ? <Eye size={18} /> : <EyeSlash size={18} />}
      </span>{" "}
      <span className="small">{label}</span>
    </Button>
  );
};

TopicLayerSelector.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  label: PropTypes.string.isRequired,
  setLayersVisibility: PropTypes.func.isRequired,
};

export default withMapActions(TopicLayerSelector);
